import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

import { AuthService } from '../security';

@Injectable({ providedIn: 'root' })
export class CardioGuard implements CanActivate {
    constructor(private authService: AuthService) {}

    canActivate() {
        return (
            this.authService.isAdmin ||
            this.authService.canEditMedicalInfos.cardio ||
            this.authService.canEditAdministrativeInfos.cardio
        );
    }
}
